/* Approximate icebox pin via OpenStreetMap embed (no extra map SDK). */
export default function IceboxMap({ lat, lng, label = "Icebox", height = 220 }) {
  if (lat == null || lng == null || Number.isNaN(Number(lat)) || Number.isNaN(Number(lng))) {
    return (
      <div className="rounded-xl border border-[#673c96]/10 bg-[#faf8fc] px-4 py-8 text-center text-sm text-[#673c96]"
        style={{ minHeight: height }}>
        Waiting for GPS from the icebox…
      </div>
    );
  }
  const la = Number(lat);
  const ln = Number(lng);
  const d = 0.012;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${ln - d}%2C${la - d}%2C${ln + d}%2C${la + d}&layer=mapnik&marker=${la}%2C${ln}`;
  return (
    <div className="overflow-hidden rounded-xl border border-[#673c96]/15" data-testid="icebox-map">
      <iframe title={label} src={src} className="w-full border-0" style={{ height }} loading="lazy" />
      <p className="px-3 py-1.5 text-[11px] text-[#6b7280] bg-white">
        Approximate icebox location · {la.toFixed(4)}, {ln.toFixed(4)}
      </p>
    </div>
  );
}
